export const FREE_CELL = 0;
export const CELL_HIT = 1;
export const CELL_MISS = 2;

export const CARRIER = {
  name: "Carrier",
  type: 1,
  size: 5,
  quantity: 1,
  color: "silver",
};

export const BATTLESHIP = {
  name: "Battleship",
  type: 2,
  size: 4,
  quantity: 1,
  color: "slategrey",
};

export const CRUISER = {
  name: "Cruiser",
  type: 3,
  size: 3,
  quantity: 1,
  color: "aquamarine",
};

export const SUBMARINE = {
  name: "Submarine",
  type: 4,
  size: 3,
  quantity: 1,
  color: "skyblue",
};

export const DESTROYER = {
  name: "Destroyer",
  type: 5,
  size: 2,
  quantity: 1,
  color: "khaki",
};
